import { ref, computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import axios from 'axios'

// Global reactive state
const showPopup = ref(false)
const isClosing = ref(false)
const hasInitialized = ref(false)

export default {
  install(app) {
    // Make the popup state globally available
    app.config.globalProperties.$changelogPopup = {
      show: showPopup,
      isClosing,
      close: closePopup
    }

    // Provide for composition API
    app.provide('changelogPopup', {
      show: showPopup,
      isClosing,
      close: closePopup
    })
  }
}

// Get the changelog data from Inertia shared props
export const useChangelogPopup = () => {
  const page = usePage()
  
  const changelogData = computed(() => {
    return page.props.changelogPopup || null
  })

  const shouldShowPopup = computed(() => {
    return changelogData.value && 
           changelogData.value.shouldShow && 
           !isClosing.value
  })

  // Initialize popup visibility based on shared data
  // Only show popup once per page load when conditions are met
  const initializePopup = () => {
    if (!hasInitialized.value && shouldShowPopup.value && !showPopup.value) {
      showPopup.value = true
      hasInitialized.value = true
    }
  }

  return {
    showPopup,
    isClosing,
    changelogData,
    shouldShowPopup,
    closePopup,
    initializePopup
  }
}

// Close popup function
export const closePopup = async () => {
  if (isClosing.value) return // Prevent multiple simultaneous calls
  
  isClosing.value = true
  showPopup.value = false

  try {
    // Send request to mark changelog as read for current user
    await axios.post('/changelog/mark-read')
    
    // Manually hide the popup since we're not using Inertia's state management
    // The next page load will reflect the updated state
  } catch (error) {
    console.error('Error closing changelog popup:', error)
    // Optionally show an error message to the user
  } finally {
    isClosing.value = false
  }
} 